import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { AddIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, PaperClipIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon, EnvelopeIcon, RefreshIcon } from "../svg/svgIcons";
import { DateTime } from "luxon";
import UtilContext from '../../components/UtilContext';
import { MaintenanceMaskDialogCheckbox } from '../../components/maintenance/MaintenanceMaskDialogCheckbox';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import ReactDOMServer from 'react-dom/server';
import * as XLSX from 'xlsx';
import { useFormik } from 'formik';
import { MultiSelect } from 'primereact/multiselect';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { getMntnSemaforColor, getSemaforColorClass } from '../../utils/moduleSettings';
import AuthContext from '../../components/AuthContext';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { showDeactivatedInLists, showExcludedMachinesInLists } from '../../utils/moduleSettings';
import { toLocalDateString } from '../../utils/previewDateRange';
import { cleanSorters, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart, applyUserMaskRowToTabulator, mergePagedStandardListFiltersAndSorters, appendMaintenanceStateListPagedFilter, getTabulatorInitialSortUnlessMaskHasSorters, safeParse } from '../../utils/tabulatorProgressiveLoading';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { getPusherChannel } from '../../utils/pusherChannel';
import { getEffectiveMask } from '../../utils/effectiveMask';
import {
  buildMaintenanceMaskAkcieSubItems,
  createConfirmSaveStandardMask,
  createConfirmApplyStandardLayoutToUserMask,
  createSaveUserMaskColumns,
  createOpenMaskDialog,
  createMaskSetFieldHandler,
  createMaskSelectAllHandler,
  createMaskDeselectAllHandler,
  hasApplicableStandardMaskRow,
  MAINTENANCE_MASK_DIALOG_SKIP_FIELDS,
} from '../../utils/maintenanceTabulatorMaskActions';
import {
  buildScheduledTreeAuditTabulatorColumns,
  mergeColumnVisibilityWithAuditDefaults,
  scheduleExpandRemoteTreeRowsForActiveAuditFilter,
} from '../../utils/tabulatorAuditColumns';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import {
  buildCanonicalPrintFooterHtml,
  buildCanonicalPrintHeaderHtml,
} from '../../utils/printChrome';
const MAINTENANCE_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'machine.name': 'Common.MachineName',
  'machine.machine_type.name': 'MachineList.Column.MachineTypeName',
  'custom_maintenance_type_name': 'MaintenanceStateList.Text.Nazov_pl_ukonu',
  'custom_last_execution_date': 'Common.LastPerformed',
  'custom_expiration': 'Common.Expiration',
  'custom_state': 'Common.Status',
  'custom_stav_ukonu': 'Common.TaskStatus',
  'machine.activity': 'Common.MachineStatus',
  'maintenance_type.interval_months': 'Common.IntervalMonths',
  'custom_company_contact_name': 'Common.ServiceTechnician',
  'machine_part': 'Common.MachinePart',
  'maintenance_type.type': 'Common.TaskType',
  'maintenance_type.norm': 'Common.Norm',
  'maintenance_type.responsible.name': 'Common.Column.Responsible',
  'maintenance_type.description': 'MaintenanceStateList.Text.Popis_planovaneho_ukonu',
  'description': 'Common.Description',
  'files': 'Common.Protocol',
  'custom_next_execution_date': 'Common.NextPerformed',
  'scheduled_files': 'Common.Template',
  'company.name': 'Common.ServiceCompany',
  'custom_lecturer_name': 'Common.TechnicianType',
});



const MASK_PAGE = 'MaintenanceStateList';

const DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY = Object.freeze({
  id: true,
  'machine.name': true,
  'machine.machine_type.name': true,
  custom_maintenance_type_name: true,
  custom_last_execution_date: true,
  custom_next_execution_date: true,
  files: true,
  protocol: true,
  scheduled_files: true,
  custom_expiration: true,
  custom_state: true,
  custom_stav_ukonu: true,
  'machine.activity': true,
  'maintenance_type.interval_months': true,
  'company.name': true,
  custom_lecturer_name: true,
  custom_company_contact_name: true,
  machine_part: true,
  'maintenance_type.type': true,
  'maintenance_type.norm': true,
  'maintenance_type.responsible.name': true,
  'maintenance_type.description': true,
  description: true,
  created_at: true,
  updated_at: true,
});

function mergeMaintenanceStateColumnVisibilityFromSaved(saved) {
  return mergeColumnVisibilityWithAuditDefaults(DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY, saved);
}

function applyMaintenanceStateDataColumnVisibility(table, visibility) {
  if (!table) return;
  for (const field of Object.keys(DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY)) {
    if (visibility[field] === false) table.hideColumn?.(field);
    else table.showColumn?.(field);
  }
}

export default function MaintenanceStateList({ preview = null, preview_period = null, preview_segment = null }) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,setStandardMaskFilter,openFilePreview,getDateFormat,getUserColor,getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);

    const [invitationIcon,setInvitationIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);

    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleInvitation,setVisibleInvitation] = useState(false);
    const [lecturers, setLecturers] = useState(state.lecturers);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [machines, setMachines] = useState(state.machines);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const effectiveCompanyContacts = (state.company_contacts || []).length ? (state.company_contacts || []) : companyContactsList;

    useEffect(() => {
        if ((state.company_contacts || []).length > 0) return;
        getRequest("/api/company_contacts?minimal=1&module=maintenance")
            .then((r) => { const list = r?.data ?? r ?? []; setCompanyContactsList(Array.isArray(list) ? list : []); })
            .catch(() => {});
    }, [state.company_contacts?.length]);

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [searchValue,setSearchValue] = useState('');

    const [columnsVisible, setColumnsVisible] = useState(() => ({ ...DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY }));

    const [maskVisible, setMaskVisible] = useState(false);
const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);


    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const auditTreeExpandInProgressRef = useRef(false);
    const auditTreeExpandScheduleRef = useRef(null);
    const savedHScrollRef = useRef({ left: 0, pending: false });

    const pageSizePcStateList = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);

    const initialSortOption = useMemo(
      () =>
        getTabulatorInitialSortUnlessMaskHasSorters({
          userMaskFilters: state.user_mask_filters,
          maskPage: 'MaintenanceStateList',
          skipMask: preview != null || preview_period != null,
          defaultSort: [{ column: 'machine.name', dir: 'asc' }],
        }),
      [state.user_mask_filters, preview, preview_period]
    );

    const showDeactivated = showDeactivatedInLists(state.module_settings, 'maintenance');
    const showExcludedMachines = showExcludedMachinesInLists(state.module_settings);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const scheduleAuditTreeExpand = useCallback(() => {
      if (isRestoringRef.current) return;
      scheduleExpandRemoteTreeRowsForActiveAuditFilter(getTable, auditTreeExpandInProgressRef, auditTreeExpandScheduleRef);
    }, [getTable]);

    useEffect(() => () => {
      if (auditTreeExpandScheduleRef.current != null) {
        clearTimeout(auditTreeExpandScheduleRef.current);
      }
    }, []);
    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      const apply = () => {
        holder.scrollLeft = left;
        if (header) header.scrollLeft = left;
      };
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(apply, 50);
          setTimeout(() => {
            if (savedHScrollRef.current.pending) {
              apply();
              savedHScrollRef.current.pending = false;
            }
          }, 180);
        });
      });
    }, [getTable]);

    // Pusher: machine_card.created/updated/deleted – payload { id (card), machine_id }; tento list používa card id
    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const onCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.created', id)) return;
        getRequest(`/api/machine_cards/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {});
      };
      const onUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.updated', id)) return;
        getRequest(`/api/machine_cards/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
        }).catch(() => {});
      };
      const onDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('machine_card.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      channel.bind('machine_card.created', onCreated);
      channel.bind('machine_card.updated', onUpdated);
      channel.bind('machine_card.deleted', onDeleted);
      return () => {
        channel.unbind('machine_card.created', onCreated);
        channel.unbind('machine_card.updated', onUpdated);
        channel.unbind('machine_card.deleted', onDeleted);
      };
    }, [getTable]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePcStateList;
      extra.show_deactivated = showDeactivated ? '1' : '0';
      extra.show_excluded_machines = showExcludedMachines ? '1' : '0';
      // Period drilldown: BE DashboardTimeliness (mobile /maintenanceplan parity).
      if (preview_period && preview_segment) {
        const fromRaw = preview_period.dateFrom;
        const toRaw = preview_period.dateTo;
        extra.filter_preview_period_from = typeof fromRaw === 'string'
          ? fromRaw
          : (toLocalDateString(fromRaw instanceof Date ? fromRaw : new Date(fromRaw)) ?? '');
        extra.filter_preview_period_to = typeof toRaw === 'string'
          ? toRaw
          : (toLocalDateString(toRaw instanceof Date ? toRaw : new Date(toRaw)) ?? '');
        extra.filter_preview_segment = preview_segment;
      }
      // CURRENT Všetko buckets: same API tokens as mobile maintenancePreviewDrilldownParams.
      if (preview && !preview_period) {
        extra.filter_custom_state = preview === 'others' ? 'OK' : 'OK,NOK';
        const expMap = { after: '0-', '15': '15-', '30': '30-', others: '45-,60-,61+' };
        if (expMap[preview]) extra.filter_custom_expiration = expMap[preview];
      }
      const tableReadyForParams = tableBuiltRef.current;
      const useMask = !preview && !preview_period;
      mergePagedStandardListFiltersAndSorters(extra, {
        getTable,
        tableBuiltForParams: tableReadyForParams,
        userMaskFilters: state.user_mask_filters,
        maskPage: 'MaintenanceStateList',
        useMaskFromRedux: useMask,
        appendFilter: appendMaintenanceStateListPagedFilter,
      });
      if (!extra.sorters && !tableReadyForParams && useMask) {
        extra.sorters = JSON.stringify([{ field: 'machine.name', dir: 'asc' }]);
      }
      if (!extra.sorters && (preview || preview_period)) {
        extra.sorters = JSON.stringify([{ field: 'machine.name', dir: 'asc' }]);
      }
      return extra;
    }, [getTable, pageSizePcStateList, showDeactivated, showExcludedMachines, state.user_mask_filters, preview, preview_period, preview_segment]);

    // --- PRILOHY ---
  const [recordFiles, setRecordFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);

  function viewFile(file_id){
      getRequest(`/api/maintenance_scheduled_records/protocol/${file_id}`).then((response) => {
          if (response?.data?.url) openFilePreview({ url: response.data.url, filename: response.data.filename });
      });
  }

  /** Otvorenie predlohy z karty stroja (MaintenanceScheduledFile) */
  function viewFileCard(file_id){
      getRequest(`/api/machine_cards/protocol/${file_id}`).then((response) => {
          const d = response?.data?.data ?? response?.data;
          if (d?.url) openFilePreview({ url: d.url, filename: d.filename });
      });
  }

    // Protokol = len MaintenanceScheduledRecordFile (súbory záznamu). Pri karte (aj Nevykonané) nikdy nepoužívať rowData.files – to sú predlohy (MaintenanceScheduledFile).
    function Protocol(props) {
        const rowData = props.cell.getRow().getData();
        const isCardRow = rowData?._children !== undefined && Array.isArray(rowData._children);
        const recordFiles = isCardRow ? (rowData._children[0]?.files || []) : (rowData.files || []);
        const hasFiles = Array.isArray(recordFiles) && recordFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {recordFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFile(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    function ResponsibleFormatter(props) {
      const row = props.cell.getRow();
      const rowData = row.getData();
      const parent = row.getTreeParent();
      const cardData = parent ? parent.getData() : rowData;
      const mt = cardData?.maintenance_type;
      if (mt?.use_central_responsible_person) {
        return <>{mt?.responsible?.name ?? '—'}</>;
      }
      return <>{cardData?.responsible?.name ?? ''}</>;
    }

    function Predloha(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardFiles = parent ? (parent.getData()?.files || []) : (rowData?.files || []);
        const hasFiles = Array.isArray(cardFiles) && cardFiles.length > 0;
        if (!hasFiles) return null;
        return (
            <div className='flex flex-row'>
                {cardFiles.map((img) => (
                    <a key={img.id} style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px', width: '24px', display: 'block' }} onClick={() => { viewFileCard(img.id); }} title={img.filename}><PaperClipIcon /></a>
                ))}
            </div>
        );
    }

    function ServisnaFirmaFormatter(props) {
        const row = props.cell.getRow();
        const rowData = row.getData();
        const parent = row.getTreeParent();
        const cardData = parent ? parent.getData() : rowData;
        const name = getEffectiveServiceCompanyName(cardData, rowData);
        return <>{name}</>;
    }


    const normalizeText = (value) => (value ?? "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function matchAny(data, filterParams) {
      const search = normalizeText(filterParams.value || "");
      if (!search) return true;

      for (const key in data) {
        if (normalizeText(data[key]).includes(search)) {
          return true;
        }
      }
      return false;
    }

    function searchTable(){
      ref.current.setFilter(matchAny, { value: searchValue});
      setSearchIconColor("active");
      if (searchValue === " ") {
        ref.current.clearFilter()
      }
      setVisibleSearch(false);
    }

      function MaintenanceTypeName(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.maintenance_type.name}</div>;
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotné vykonanie</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakované vykonanie</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.maintenance_type.name}</div>;
        }
    } 

    function MachineFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='training_name'>{rowData.machine?.name}</div>;
    }

    function machineHeaderFilter(headerValue, rowValue, rowData, filterParams) {
      if (!headerValue || headerValue.trim() === "") return true;
      const normalize = (val) =>
          (val || "")
              .toString()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
      const haystack = normalize(rowData?.machine?.name);
      const needle = normalize(headerValue);
      return haystack.includes(needle);
  }

      function LastExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].last_execution_date).toFormat(dateFmt);
        if(rowData?.last_execution_date) return DateTime.fromISO(rowData?.last_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
      }

      function NextExecutionDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].next_execution_date).toFormat(dateFmt);
        if(rowData?.next_execution_date) return DateTime.fromISO(rowData?.next_execution_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('Common.NotPerformed')}</span>;
      }

      function StateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==0){
                        if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                            return "DEA";
                        }
                        else if(new Date(parent_array[i]?.next_execution_date) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK";
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="") return "DEA";
        if(rowData?._children?.length > 0){           
            if(new Date(rowData?._children[0]?.next_execution_date) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
          return "OK";
        }
        else return "NOK";
      }

    function StavUkonuFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return (rowData?.deactivation_date != null && rowData?.deactivation_date !== "") ? t('Status.Excluded') : "Aktívny";
    }

    function ExpirationFormatter(props) {
      const rowData = props.cell.getRow().getData();
      const parent = props.cell.getRow()?.getTreeParent();
      let bucket = '';
      if (!parent) {
        if (rowData?.deactivation_date != null && rowData?.deactivation_date !== '') bucket = 'DEA';
        else if (rowData?._children?.length > 0) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const upcoming = rowData._children
            .map((c) => c?.next_execution_date && new Date(c.next_execution_date))
            .filter((d) => d && !isNaN(d.getTime()) && d >= today);
          const minNext = upcoming.length > 0 ? new Date(Math.min(...upcoming.map((d) => d.getTime()))) : null;
          if (minNext == null) {
            bucket = '0-';
          } else {
            const now = new Date();
            const endOfDay = (d, days) => { const x = new Date(d); x.setDate(x.getDate() + days); x.setHours(23, 59, 59, 999); return x; };
            if (minNext <= endOfDay(now, 15)) bucket = '15-';
            else if (minNext <= endOfDay(now, 30)) bucket = '30-';
            else if (minNext <= endOfDay(now, 45)) bucket = '45-';
            else if (minNext <= endOfDay(now, 60)) bucket = '60-';
            else bucket = '61+';
          }
        } else if (rowData?.initial_date && new Date(rowData.initial_date) > new Date()) bucket = '';
        else bucket = '0-';
      }
      if (bucket === '') return '';
      const module_settings = state?.module_settings || [];
      const color = getMntnSemaforColor(module_settings, bucket);
      const colorClass = getSemaforColorClass(color);
      return (
        <span className="inline-flex items-center gap-1.5">
          <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${colorClass}`} title={bucket} />
          <span>{bucket}</span>
        </span>
      );
    }

    function maintenanceTypeNameHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (!headerValue || headerValue.trim() === "") return true;
        const name = (rowData?.maintenance_type?.name || "").toUpperCase();
        return name.includes(headerValue.toUpperCase());
    }


    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
      if (!headerValue || headerValue.trim() === "") return true;
      const hv = headerValue.trim();
      const n = normalizeText(hv);
      // keď nemá children
      if (!rowData?._children || rowData._children.length === 0) {
        if (new Date(rowData?.initial_date) > new Date()) {
          return normalizeText(t('Common.Scheduled')).includes(n);
        }
        return normalizeText(t('Common.NotPerformed')).includes(n);
      }
      // keď má children – substring v zobrazenom dátume (dd.MM.yyyy / modul) + ISO zdroj
      const child0 = rowData._children[0];
      if (!child0) return false;
      if (filterParams?.name === "last_execution_date") {
        const iso = child0.last_execution_date ? String(child0.last_execution_date) : "";
        const formatted = child0.last_execution_date ? DateTime.fromISO(child0.last_execution_date).toFormat(dateFmt) : "";
        return normalizeText(formatted).includes(n) || normalizeText(iso).includes(n);
      }
      if (filterParams?.name === "next_execution_date") {
        const iso = child0.next_execution_date ? String(child0.next_execution_date) : "";
        const formatted = child0.next_execution_date ? DateTime.fromISO(child0.next_execution_date).toFormat(dateFmt) : "";
        return normalizeText(formatted).includes(n) || normalizeText(iso).includes(n);
      }
      return true;
    }


    function expirationHeaderFilter(headerValue, rowValue, rowData){
      if (!headerValue || String(headerValue).trim() === "") return true;
      const selected = new Set(String(headerValue).split(',').map((s) => s.trim()).filter(Boolean));
      selected.delete(t('Common.All'));
      if (selected.size === 0) return true;

      let state = "";

      if (rowData?.deactivation_date) {
        state = "DEA";
      } else if (rowData?._children?.length > 0) {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const nowTs = now.getTime();
        const futureDates = rowData._children
          .map(c => c.next_execution_date ? new Date(c.next_execution_date) : null)
          .filter(d => d && !isNaN(d.getTime()));
        const futureOnly = futureDates.filter(d => {
          const t = new Date(d);
          t.setHours(0, 0, 0, 0);
          return t.getTime() >= nowTs;
        });
        const d = futureOnly.length > 0
          ? new Date(Math.min(...futureOnly.map(x => new Date(x).getTime())))
          : (futureDates.length > 0 ? new Date(Math.min(...futureDates.map(x => new Date(x).getTime()))) : null);

        if (!d || isNaN(d.getTime())) state = "0-";
        else {
          const dTime = new Date(d).getTime();
          const endOfDay = (days) => { const x = new Date(now); x.setDate(x.getDate() + days); x.setHours(23, 59, 59, 999); return x.getTime(); };
          if (dTime < nowTs) state = "0-";
          else if (dTime <= endOfDay(15)) state = "15-";
          else if (dTime <= endOfDay(30)) state = "30-";
          else if (dTime <= endOfDay(45)) state = "45-";
          else if (dTime <= endOfDay(60)) state = "60-";
          else state = "61+";
        }
      } else if (new Date(rowData?.initial_date) > new Date()) {
        state = "";
      } else {
        state = "0-";
      }

      if (state === "") return false;

      return selected.has(state);
    }

    function stateHeaderFilter(headerValue, rowValue, rowData){
      if (!headerValue || String(headerValue).trim() === "") return true;
      let state = "";
      if (rowData?.deactivation_date) state = "DEA";
      else if (rowData?._children?.length > 0) {
        state = new Date(rowData._children[0]?.next_execution_date) < new Date() ? "NOK" : "OK";
      } else if (new Date(rowData?.initial_date) > new Date()) {
        state = "OK";
      } else {
        state = "NOK";
      }
      const selected = new Set(String(headerValue).split(',').map(s => s.trim().toUpperCase()).filter(Boolean));
      return selected.has(state.toUpperCase());
    }
    function stavUkonuHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || String(headerValue).trim() === "") return true;
      const label = (rowData?.deactivation_date != null && rowData?.deactivation_date !== "") ? t('Status.Excluded') : "Aktívny";
      const selected = new Set(String(headerValue).split(',').map(s => s.trim()).filter(Boolean));
      return selected.has(label);
    }
    function stavStrojaHeaderFilter(headerValue, rowValue) {
      if (!headerValue || String(headerValue).trim() === "") return true;
      const selected = new Set(String(headerValue).split(',').map(s => s.trim()).filter(Boolean));
      const val = String(rowValue ?? '').trim();
      return selected.has(val);
    }

    const LECTURER_EXTERNAL = t('Common.ServiceCompanyEmployee');
    const LECTURER_INTERNAL = t('Common.InternalEmployee');

    function getCompanyContactFromRow(rowData, allContacts = []) {
      if (rowData?.company_contact) return rowData.company_contact;
      const id = rowData?.company_contact_id;
      if (!id) return null;
      return allContacts.find(c => String(c.id) === String(id)) || null;
    }

    function getLecturerLabelFromContact(cc) {
      if (!cc) return "";
      return cc.employee_id != null ? LECTURER_INTERNAL : LECTURER_EXTERNAL;
    }

    function getLecturerLabelFromRow(rowData, allContacts = []) {
      const cc = getCompanyContactFromRow(rowData, allContacts);
      return getLecturerLabelFromContact(cc);
    }

    /** Efektívna servisná firma (centrálna z typu alebo z karty / záznamu) – rovnako ako v MaintenanceCardDetail. */
    function getEffectiveServiceCompanyName(cardData, rowData) {
      const mt = cardData?.maintenance_type;
      if (mt?.use_central_service_person && (mt?.central_company_id || mt?.central_company_contact_id)) {
        return mt?.centralCompany?.name || mt?.central_company?.name || '';
      }
      return rowData?.company?.name || cardData?.company?.name || '';
    }

    function getCentralServiceContactFromCard(cardData) {
      const mt = cardData?.maintenance_type;
      if (!mt?.use_central_service_person || !(mt?.central_company_id || mt?.central_company_contact_id)) return null;
      return mt?.centralCompanyContact || mt?.central_company_contact || null;
    }

    function getEffectiveCompanyContactForRow(rowData, cardData, allContacts) {
      const central = getCentralServiceContactFromCard(cardData);
      if (central) return central;
      return getCompanyContactFromRow(rowData, allContacts) || getCompanyContactFromRow(cardData, allContacts);
    }

    function getEffectiveLecturerLabelForRow(rowData, cardData, allContacts) {
      const cc = getEffectiveCompanyContactForRow(rowData, cardData, allContacts);
      return getLecturerLabelFromContact(cc);
    }

    function getEffectiveContactNameForRow(rowData, cardData, allContacts) {
      const cc = getEffectiveCompanyContactForRow(rowData, cardData, allContacts);
      if (!cc) return '';
      return cc.employee_id != null ? (cc.employee?.name || '') : (cc.name || '');
    }

    function LecturerName(props) {
      const row = props.cell.getRow();
      const rowData = row.getData();
      const parent = row.getTreeParent();
      const cardData = parent ? parent.getData() : rowData;
      return getEffectiveLecturerLabelForRow(rowData, cardData, effectiveCompanyContacts);
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || headerValue.trim() === "") return true;
      const label = rowData?.maintenance_type
        ? getEffectiveLecturerLabelForRow(rowData, rowData, effectiveCompanyContacts)
        : getLecturerLabelFromRow(rowData, effectiveCompanyContacts);
      if (!label) return false;
      return normalizeText(label).includes(normalizeText(headerValue));
    }

    function ContactFormatter(props) {
      const row = props.cell.getRow();
      const rowData = row.getData();
      const parent = row.getTreeParent();
      const cardData = parent ? parent.getData() : rowData;
      return getEffectiveContactNameForRow(rowData, cardData, effectiveCompanyContacts);
    }

    function contactHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || headerValue.trim() === "") return true;
      const name = rowData?.maintenance_type
        ? getEffectiveContactNameForRow(rowData, rowData, effectiveCompanyContacts)
        : (() => {
            const cc = getCompanyContactFromRow(rowData, effectiveCompanyContacts);
            return (cc?.employee?.name || cc?.name || '');
          })();
      return normalizeText(name).includes(normalizeText(headerValue));
    }

    function serviceCompanyHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue) return true;
      const name = rowData?.maintenance_type
        ? getEffectiveServiceCompanyName(rowData, rowData)
        : (rowData?.company?.name || '');
      return normalizeText(name).includes(normalizeText(headerValue));
    }


  function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
    if (!headerValue) return true; // prázdny filter = všetko
    return normalizeText(rowValue).includes(normalizeText(headerValue));
  }

  const dateFormatGlob = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
  const dateTimeFormatGlob = `${dateFormatGlob} HH:mm`;

  const auditColumns = useMemo(
    () =>
      buildScheduledTreeAuditTabulatorColumns({
        includeId: true,
        dateFormat: dateFormatGlob,
        dateTimeFormat: dateTimeFormatGlob,
        getUserColor,
        getUserInitials,
        textHeaderFilter,
      }),
    [dateFormatGlob, dateTimeFormatGlob, getUserColor, getUserInitials, textHeaderFilter]
  );

  const idColumn = useMemo(() => auditColumns.find((c) => c.field === 'id'), [auditColumns]);
  const createdAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'created_at'), [auditColumns]);
  const updatedAtColumn = useMemo(() => auditColumns.find((c) => c.field === 'updated_at'), [auditColumns]);

  const columns = useMemo(() => [
      { title: '', field: 'rowSelection', formatter:"rowSelection", titleFormatter:"rowSelection", titleFormatterParams:{rowRange:"active"}, hozAlign:"center", width: 44, headerSort:false, resizable:false, frozen: true, print: false, download: false,
        cellClick: function(e, cell) {
          cell.getRow().toggleSelect();
        }
      },
      { title: '', field: 'editor', visible:false, frozen: true, print: false, download: false },
      idColumn,
      { title: t('Common.MachineName'), field: 'machine.name',formatter: reactFormatter(<MachineFormatter/>),headerFilter:"input",headerFilterFunc:machineHeaderFilter,minWidth: 280,widthGrow:2},
      { title: t('MachineList.Column.MachineTypeName'), field: 'machine.machine_type.name', minWidth: 200,
      headerFilter: primeMultiSelectHeaderFilter,
      headerFilterParams: { placeholder: t('Common.All'), valueType: 'string', options: (state.machine_types || []).map(mt => ({ label: mt.name, value: mt.name })) },
      headerFilterFunc: (headerValue, rowValue) => {
        if (!headerValue) return true;
        const selected = new Set(String(headerValue).split(',').map((x) => x.trim()).filter(Boolean));
        return selected.has(String(rowValue ?? ''));
      }
    },
      { title: t('MaintenanceStateList.Text.Nazov_pl_ukonu'), field: 'custom_maintenance_type_name',minWidth: 250,widthGrow:3,headerFilter:"input",headerFilterFunc:maintenanceTypeNameHeaderFilter,formatter: reactFormatter(<MaintenanceTypeName/>)},
      { title: t('Common.LastPerformed'), field: 'custom_last_execution_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"last_execution_date"},minWidth: 220,widthGrow:1,formatter: reactFormatter(<LastExecutionDate/>)},
      { title: t('Common.NextPerformed'), field: 'custom_next_execution_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"next_execution_date"},minWidth: 210,widthGrow:1,formatter: reactFormatter(<NextExecutionDate/>)},
      { title: t('Common.Protocol'), field: "files", width: 150, hozAlign:"center", headerHozAlign:"center", formatter: reactFormatter(<Protocol />) },
      { title: t('Common.Template'), field: 'scheduled_files', width: 150, hozAlign: 'center', headerHozAlign: 'center', formatter: reactFormatter(<Predloha />) },
      { title: t('Common.Expiration'), field: 'custom_expiration', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Expiration'), options: [{ label: '61+', value: '61+' }, { label: '60-', value: '60-' }, { label: '45-', value: '45-' }, { label: '30-', value: '30-' }, { label: '15-', value: '15-' }, { label: '0-', value: '0-' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: expirationHeaderFilter, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<ExpirationFormatter/>) },
      { title: t('Common.Status'), field: 'custom_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Status'), options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: stateHeaderFilter, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<StateFormatter/>) },
      { title: t('Common.TaskStatus'), field: 'custom_stav_ukonu', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.TaskStatus'), options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Status.Excluded'), value: 'Vyradený' }] }, headerFilterFunc: stavUkonuHeaderFilter, minWidth: 180, widthGrow: 1, formatter: reactFormatter(<StavUkonuFormatter/>) },
      { title: t('Common.MachineStatus'), field: 'machine.activity', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.MachineStatus'), options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Status.Excluded'), value: 'Vyradený' }] }, headerFilterFunc: stavStrojaHeaderFilter, minWidth: 200 },
      { title: t('Common.IntervalMonths'), field: 'maintenance_type.interval_months',headerFilter:"input",headerFilterFunc:textHeaderFilter,minWidth: 220 },
      { title: t('Common.ServiceCompany'), field: 'company.name',headerFilter:"input",headerFilterFunc:serviceCompanyHeaderFilter,minWidth: 200, formatter: reactFormatter(<ServisnaFirmaFormatter/>)},
      { title: t('Common.TechnicianType'), field: 'custom_lecturer_name',headerFilter:"input",minWidth: 200,formatter: reactFormatter(<LecturerName/>),headerFilterFunc:lecturerHeaderFilter },
      { title: t('Common.ServiceTechnician'), field: 'custom_company_contact_name',headerFilter:"input",minWidth: 210,formatter: reactFormatter(<ContactFormatter/>), headerFilterFunc:contactHeaderFilter},
      { title: t('Common.MachinePart'), field: 'machine_part',headerFilter:"input",headerFilterFunc: textHeaderFilter,minWidth: 200,},
      { title: t('Common.TaskType'), field: 'maintenance_type.type',headerFilter:"input",headerFilterFunc:textHeaderFilter,minWidth: 200 },
      { title: t('Common.Norm'), field: 'maintenance_type.norm',headerFilter:"input",headerFilterFunc:textHeaderFilter,minWidth: 200 },
      { title: t('Common.Column.Responsible'), field: 'maintenance_type.responsible.name',headerFilter:"input",headerFilterFunc:textHeaderFilter,minWidth: 210, formatter: reactFormatter(<ResponsibleFormatter/>) },
      { title: t('MaintenanceStateList.Text.Popis_planovaneho_ukonu'), field: 'maintenance_type.description',headerFilter:"input",headerFilterFunc:textHeaderFilter,minWidth: 290 },
      { title: t('Common.Description'), field: 'description',headerFilter:"input",minWidth: 200,headerFilterFunc:textHeaderFilter,widthGrow:2},
      createdAtColumn,
      updatedAtColumn,
  ].filter(Boolean), [idColumn, createdAtColumn, updatedAtColumn, state.machine_types, textHeaderFilter]);

    const canSetStandardMask = user?.permissions?.includes('set standard mask');

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());

    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );

    const [expandedKeys, setExpandedKeys] = useState({});
    const closeMenu = useCallback(() => {
        setTimeout(() => {
            OverflowMenuProvider.setVisible?.(null);
            setExpandedKeys({});
        }, 0);
    }, []);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: MAINTENANCE_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


    const hasApplicableStandardMask = useMemo(
        () => hasApplicableStandardMaskRow(state.standard_mask_filters, MASK_PAGE, mergeMaintenanceStateColumnVisibilityFromSaved),
        [state.standard_mask_filters]
    );

    const openMaskDialog = useCallback(
        createOpenMaskDialog({
            columnsVisible,
            setColumnsVisible,
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeMaintenanceStateColumnVisibilityFromSaved,
            setMaskVisible,
            closeMenu,
        }),
        [columnsVisible, closeMenu]
    );

    const saveUserMaskColumns = useCallback(
        createSaveUserMaskColumns({
            maskPage: MASK_PAGE,
            getTable,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            setMaskVisible,
            toast,
        }),
        [columnsVisible, getTable, setUserMaskFilter, toast]
    );

    const confirmSaveStandardMask = useCallback(
        createConfirmSaveStandardMask({
            maskPage: MASK_PAGE,
            getTable,
            setStandardMaskFilter,
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            toast,
        }),
        [getTable, setStandardMaskFilter, toast]
    );

    const confirmApplyStandardLayoutToUserMask = useCallback(
        createConfirmApplyStandardLayoutToUserMask({
            maskPage: MASK_PAGE,
            state,
            setUserMaskFilter,
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            mergeVisibilityFromSaved: mergeMaintenanceStateColumnVisibilityFromSaved,
            toast,
            closeMenu,
            onAppliedToTable: ({ colsForSave, attributes }) => {
                const table = getTable();
                if (!table) return;
                isRestoringRef.current = true;
                try {
                    table.setColumnLayout?.(attributes);
                } catch (_) {}
                setColumnsVisible(colsForSave);
                applyMaintenanceStateDataColumnVisibility(table, colsForSave);
                setTimeout(() => {
                    isRestoringRef.current = false;
                    table.redraw?.(true);
                    captureHScroll();
                    refreshFromStart();
                }, 0);
            },
        }),
        [state, closeMenu, getTable, setUserMaskFilter, toast]
    );

    const setMask = useCallback(
        createMaskSetFieldHandler({
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            columnsVisible,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyMaintenanceStateDataColumnVisibility,
            toast,
        }),
        [columnsVisible, getTable, toast]
    );

    const maskSelectAll = useCallback(
        createMaskSelectAllHandler({
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyMaintenanceStateDataColumnVisibility,
        }),
        [getTable]
    );

    const maskDeselectAll = useCallback(
        createMaskDeselectAllHandler({
            defaultColumnVisibility: DEFAULT_MAINTENANCE_STATE_COLUMN_VISIBILITY,
            setColumnsVisible,
            getTable,
            applyVisibilityToTable: applyMaintenanceStateDataColumnVisibility,
        }),
        [getTable]
    );

    const handleClickOutside = (event) => {
      if (event.target.closest('[data-overflow-trigger]')) return;
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
        OverflowMenuProvider.setVisible?.(null);
      }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => document.removeEventListener('click', handleClickOutside, true);
    }, []);

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: buildMaintenanceMaskAkcieSubItems({
          maskPage: MASK_PAGE,
          getTable,
          setUserMaskFilter,
          cleanSorters,
          captureHScroll,
          refreshFromStart,
          closeMenu,
          openMaskDialog,
          openChosenNotificationPreferences,
          hasApplicableStandardMask,
          confirmApplyStandardLayoutToUserMask,
          itemRenderer,
        }),
      }
    ];

    const exportToExcel = () => {
        const excel_type = {};
        const table = getTable();
        let error_records = (table?.getData?.("active") ?? []).filter((x) => x?.maintenance_type).map((x) => {
        let id = x.id;
        let nazov_stroja = x?.machine?.name;
        let druh_stroja = x?.machine?.machine_type?.name;
        let nazov_planovaneho_ukonu = x?.maintenance_type?.name;
        let posledne_vykonanie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.last_execution_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let nasledujuce_vykonanie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.next_execution_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let expiracia = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="")expiracia = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_execution_date) < new Date()){
                  expiracia="NOK";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 15))){
                expiracia="15-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 30))){
                expiracia="30-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 45))){
                expiracia="45-";
              }
              else if(new Date(x?._children[0]?.next_execution_date) <= new Date(new Date().setDate(new Date().getDate() + 60))){
                expiracia="60-";
              }
              else expiracia="OK";
          }
          else expiracia="NOK";
        }
        let stav = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="") stav = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_execution_date) < new Date()){
                  stav = "NOK";
              }
              else stav = "OK"
          }
          else stav = "NOK";
        }
        let interval = x?.maintenance_type?.interval;
        const ccExport = getEffectiveCompanyContactForRow(x, x, effectiveCompanyContacts);
        let servisna_firma = getEffectiveServiceCompanyName(x, x);
        let servisny_technik = ccExport ? (ccExport.employee_id != null ? (ccExport.employee?.name || '') : (ccExport.name || '')) : '';
        let zodpovedna_osoba = x?.maintenance_type?.employee?.name;
        let popis_planevaneho_ukoonu = x?.maintenance_type?.description;
        let popis = x?.description;
        return {
            id,nazov_stroja,druh_stroja,nazov_planovaneho_ukonu,posledne_vykonanie,nasledujuce_vykonanie,expiracia,stav,
            interval,servisna_firma,servisny_technik,zodpovedna_osoba,popis_planevaneho_ukoonu,popis
    
        };
        }).sort((a, b) => (parseInt(a.specific_id) > parseInt(b.specific_id)) ? -1 : 1);
        const worksheet = XLSX.utils.json_to_sheet(error_records);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Planovane ukony podla stavu");
        const excelBuffer = XLSX.writeFile(workbook, "planovane_ukony_podla_stavu.xlsx",{bookSST:true});//{ bookType: 'xlsx', type: 'array' });
      };

    const onSelectRow = (data, rows) => {
        setInvitationIcon(true);
        setInsertIcon(true);
        if(data.length>0){
            // Parent = riadok karty (MaintenanceScheduled): má _children alebo nemá machine_card_id. Child = záznam úkonu (MaintenanceScheduledRecord): má machine_card_id / maintenance_scheduled_id.
            let children = 0;
            let parent = 0;
            data.forEach(obj => {
                const hasChildren = obj._children !== undefined && Array.isArray(obj._children);
                const isChildRow = (obj.machine_card_id ?? obj.maintenance_scheduled_id) > 0;
                if (hasChildren || !isChildRow) {
                    parent++;
                } else {
                    children++;
                }
            });
            if(parent>0 && children==0){
                let maintenance_type_ids = data.map(obj => obj.maintenance_type_id ?? obj.maintenance_type?.id);
                maintenance_type_ids = maintenance_type_ids.filter((item, index) => maintenance_type_ids.indexOf(item) === index);
                if(maintenance_type_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                let maintenance_type_types = data.map(obj => obj.maintenance_type?.type ?? '');
                maintenance_type_types = maintenance_type_types.filter((item, index) => maintenance_type_types.indexOf(item) === index);
                if(maintenance_type_types?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                let company_ids = data.map(obj => obj.company_id);
                company_ids = company_ids.filter((item, index) => company_ids.indexOf(item) === index);
                if(company_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                // Rovnaká súčasť stroja (machine_part) – pri viacerých riadkoch; porovnanie znormalizované (diakritika, veľkosť písmen)
                if (data.length > 1) {
                    const partKeys = data.map((obj) => normalizeText((obj.machine_part ?? '').toString().trim()));
                    const distinct = [...new Set(partKeys)];
                    if (distinct.length > 1) {
                        setInvitationIcon(true);
                        return;
                    }
                }
                let lecturer_ids = data.map(obj => obj.lecturer_id);
                lecturer_ids = lecturer_ids.filter((item, index) => lecturer_ids.indexOf(item) === index);
                if(lecturer_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                let company_contact_ids = data.map(obj => obj.company_contact_id);
                company_contact_ids = company_contact_ids.filter((item, index) => company_contact_ids.indexOf(item) === index);
                if(company_contact_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                setInvitationIcon(false);
                setInsertIcon(!user?.permissions?.includes('add maintenance'));
            }
        }
    };

    const NONE_PART = "__NONE__";

    function addNewMaintenanceRecord(){
        const data = ref?.current?.getSelectedData("active") ?? [];
        if (data.length === 0) {
            toast?.current?.show({ severity: 'warn', summary: t('Common.SelectRows'), detail: t('MaintenanceStateList.Text.Oznacte_aspon_jeden_riadok_iba_rodicovske_s_rovn'), life: 5000 });
            return;
        }
        const first = data[0];
        const cc = first.company_contact || (first.company_contact_id && effectiveCompanyContacts?.find(c => String(c.id) === String(first.company_contact_id)));
        const lecturer_id = cc != null ? (cc.employee_id != null ? 1 : 0) : '';
        // Zozbierať všetky stroje zo všetkých označených riadkov (každý riadok má machine alebo machines)
        const machineMap = new Map();
        data.forEach(obj => {
            const arr = (obj.machines && obj.machines.length) ? obj.machines : (obj.machine ? [obj.machine] : []);
            (arr || []).forEach(m => { if (m && m.id) machineMap.set(m.id, m); });
        });
        const machines = Array.from(machineMap.values());
        const maintenance_type = {
            maintenance_type_id: first.maintenance_type_id ?? first.maintenance_type?.id ?? '',
            company_id: first.company_id ?? '',
            lecturer_id: lecturer_id !== '' ? lecturer_id : (first.lecturer_id ?? ''),
            company_contact_id: first.company_contact_id ?? '',
            machines,
            machine_part: first.machine_part ?? '',
            machine_part_key: (first.machine_part != null && String(first.machine_part).trim()) ? String(first.machine_part).trim() : NONE_PART,
            last_execution_date: '',
            description: first._children?.[0]?.description ?? '',
        };
        dispatch({ type: 'create_new_tab', name: t('Maintenance.NewScheduledTask'), translationKey: 'Maintenance.NewScheduledTask', legacyLabel: t('Maintenance.NewScheduledTask'), page: 'MaintenanceRecordAdd', props: { maintenance_type }, mask: 'mntn019' });
    }

    const validate = values => {
        const errors = {};
        return errors;
    };

    function changeCompany(company_id){
        setCompanyContacts(effectiveCompanyContacts.filter(contact => contact.company_id == company_id));
        formikUpdate.setFieldValue('company_id',company_id);
        formikUpdate.setFieldValue('company_contact_id','');
        formikUpdate.setFieldValue("machines",[]);
    }

    const formikUpdate = useFormik({
        initialValues: selectedRecord ? {
            id: selectedRecord?.id, maintenance_type_id: selectedRecord?.maintenance_type_id,
            last_execution_date:selectedRecord?.last_execution_date,description:selectedRecord?.description,
            company_id:selectedRecord?.company_id,company_contact_id:selectedRecord?.company_contact_id} : 
            {maintenance_type_id: '',last_execution_date: '',description:'',company_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            for(let i = 0;i<updatefileList.length;i++){
              //console.log("IMAGE :"+fileList[i].name);
              formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/maintenance_scheduled_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                formikUpdate.resetForm();
                if (updatefileList.length) {
                  setUpdateFileList([]);
                  if (updateFileListRef.current) updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                captureHScroll();
                getTable()?.replaceData?.();
                restoreHScroll();
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    // HISTORICAL Preview period segmentation only (on_time/late in range).
    // Do NOT apply CURRENT-active machine/card gates — completed work must remain visible
    // even if the machine/card is later inactive. BE filter_preview_period_* owns the live
    // list (DashboardTimeliness / mobile parity); this helper is retained as a KEEP guard.
    // eslint-disable-next-line no-unused-vars -- source-scanned by historicalPeriodKeep.test.js
    function periodSegmentFilter(data, filterParams) {
      const children = (data._children || []).slice().sort((a, b) => {
        const ta = a.last_execution_date ? new Date(a.last_execution_date).getTime() : 0;
        const tb = b.last_execution_date ? new Date(b.last_execution_date).getTime() : 0;
        return ta - tb || (Number(a.id) || 0) - (Number(b.id) || 0);
      });
      const dateFrom = filterParams.dateFrom instanceof Date ? filterParams.dateFrom : new Date(filterParams.dateFrom);
      const dateTo = filterParams.dateTo instanceof Date ? filterParams.dateTo : new Date(filterParams.dateTo);
      const wantOnTime = filterParams.segment === 'on_time';
      for (let i = 0; i < children.length; i++) {
        const rec = children[i];
        const last = rec.last_execution_date ? new Date(rec.last_execution_date) : null;
        if (!last || last < dateFrom || last > dateTo) continue;
        const prev = children[i - 1];
        const deadline = prev?.next_execution_date ? new Date(prev.next_execution_date) : null;
        const isOnTime = !deadline || last <= deadline;
        if (isOnTime === wantOnTime) return true;
      }
      return false;
    }
    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewMaintenanceRecord()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => { setVisibleSearch(true); } : () => { setSearchIconColor(""); setSearchValue(""); getTable()?.clearFilter?.(); captureHScroll(); refreshFromStart(); }}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => exportToExcel()}><ExportIcon/></button></div>
        <div className='flex w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon /></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('MaintenanceStateList.Text.Pl_ukony_podla_stavu'),"MaintenanceStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("MaintenanceStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        {canSetStandardMask ? (
          <div className="flex w-10 h-10 px-2 py-1 justify-center" data-targetid="save-standard-mask">
            <button type="button" title={t('Common.SaveStandardMask')} aria-label={t('Common.SaveStandardMask')} onClick={confirmSaveStandardMask} className="flex items-center justify-center">
              <i className="pi pi-bookmark text-white text-xl" aria-hidden="true" />
            </button>
          </div>
        ) : null}
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
    <ReactTabulator
      onRef={(r) => (ref.current = r.current)}
      className='h-[calc(100vh_-_193px)]'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          const table = getTable();
          if (!table) return;
          isRestoringRef.current = true;
          try {
            // Period population owned by buildRequestParams → filter_preview_period_* (BE).
            // CURRENT: paint header chips only; remote filters already in buildRequestParams.
            if (preview && !preview_period) {
              if (preview === "after") {
                table.setHeaderFilterValue?.("custom_state", "OK,NOK", true);
                table.setHeaderFilterValue?.("custom_expiration", "0-", true);
              } else if (preview === "15") {
                table.setHeaderFilterValue?.("custom_state", "OK,NOK", true);
                table.setHeaderFilterValue?.("custom_expiration", "15-", true);
              } else if (preview === "30") {
                table.setHeaderFilterValue?.("custom_state", "OK,NOK", true);
                table.setHeaderFilterValue?.("custom_expiration", "30-", true);
              } else {
                table.setHeaderFilterValue?.("custom_state", "OK", true);
                table.setHeaderFilterValue?.("custom_expiration", "45-,60-,61+", true);
              }
            }
            const effective = getEffectiveMask(MASK_PAGE, state);
            if (!preview && !preview_period) {
              if (effective?.type === 'user' && effective.userMask) {
                applyUserMaskRowToTabulator(table, effective.userMask, {
                  setColumnsVisible,
                  clearHeaderFiltersWhenEmpty: true,
                  applyColumnVisibilityFn: (tbl, jc, setVis) => {
                    const merged = mergeMaintenanceStateColumnVisibilityFromSaved(jc);
                    setVis(merged);
                    applyMaintenanceStateDataColumnVisibility(tbl, merged);
                  },
                });
              } else if (effective?.type === 'standard' && effective.standardMask) {
                const m = effective.standardMask;
                const attributes = safeParse(m.attributes, []);
                const jsonColumns = safeParse(m.columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                  table.setColumnLayout?.(attributes);
                }
                if (jsonColumns && typeof jsonColumns === 'object') {
                  const merged = mergeMaintenanceStateColumnVisibilityFromSaved(jsonColumns);
                  setColumnsVisible(merged);
                  applyMaintenanceStateDataColumnVisibility(table, merged);
                }
              }
            }
          } finally {
            setTimeout(() => { isRestoringRef.current = false; }, 0);
          }
          tableBuiltRef.current = true;
          if (preview_period && preview_segment) {
            refreshFromStart();
          } else if (!preview && !preview_period && getEffectiveMask(MASK_PAGE, state)?.type === 'user') {
            refreshFromStart();
          }
        },
        ...getTabulatorPersistLayoutEvents(MASK_PAGE, ref, setUserMaskFilter),
        headerFilterChanged: () => { if (!isRestoringRef.current) captureHScroll(); refreshFromStart(); },
        sortChanged: () => { if (!isRestoringRef.current) { captureHScroll(); refreshFromStart(); } },
        renderComplete: () => {
          restoreHScroll();
          scheduleAuditTreeExpand();
        },
      }}
      options={{
        layout: "fitColumns",
        renderHorizontal: "virtual",
        rowHeight: 42,
        movableColumns: true,
        headerSortTristate: true,
        dataTree: true,
        dataTreeStartExpanded: false,
        dataTreeFilter: false,
        dataTreeElementColumn: "machine.name",
        dataTreeCollapseElement: ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement: ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement: ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        ajaxURL: "/api/maintenance_scheduled_records/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingEllipsis'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePcStateList,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (!isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          scheduleAuditTreeExpand();
          return response;
        },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        printAsHtml:true,printHeader: () => buildCanonicalPrintHeaderHtml({
                      branding: state?.branding,
                      productFallbackSrc: defaultProductLogoSrc,
                      companySettingsPrint: state?.company_settings_print,
                      moduleSettings: state?.module_settings,
                      title: t('Print.Title.MaintenanceStateList'),
                      printDateLabel: t('Print.DateLabel'),
                    }),
                    printFooter: () => buildCanonicalPrintFooterHtml({
                      companySettingsPrint: state?.company_settings_print,
                    }),
        printRowRange: "active",
        initialSort: initialSortOption,
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
          <p className="text-sm text-gray-600 mb-2">{t('MaintenanceTemplateList.MaskHelp')}</p>
          <div className="flex flex-wrap gap-2 mb-2">
            <button type="button" onClick={maskSelectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.SelectAll')}</button>
            <button type="button" onClick={maskDeselectAll} className="px-3 py-1.5 text-sm bg-zinc-200 text-zinc-900 rounded-md hover:bg-zinc-300">{t('Common.DeselectAllExceptId')}</button>
          </div>
        {columns.map((item) => {
          if (!item?.field || MAINTENANCE_MASK_DIALOG_SKIP_FIELDS.has(item.field)) return null;
                    return <div 
                        key={item.field} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <MaintenanceMaskDialogCheckbox field={item.field} inputId={`msl-mask-${item.field}`} title={item.title || item.field} columnsVisible={columnsVisible} onChange={setMask} /><label htmlFor={`msl-mask-${item.field}`} className={`ml-2 ${item.field === 'id' ? '' : 'cursor-pointer'}`}>{item.title}</label>    
                    </div> 
                })} 
            <button type="button" onClick={saveUserMaskColumns} className='m-1 px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-700'>{t('Common.SaveUpper')}</button>
        </div>
      </Dialog>
</div> 
        </>
    )
}